"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const AutoFocusOnMount = () => {
  const contentRef = (0, _react.useRef)(null);
  const [wrapperFocus, setWrapperFocus] = (0, _react.useState)(undefined);
  (0, _react.useEffect)(() => {
    if (contentRef.current) {
      const wrapper = contentRef.current;
      const autoFocusSet = Boolean(wrapper.querySelectorAll('*[data-autofocus],*[autofocus]').length);
      if (!autoFocusSet) {
        setWrapperFocus(true);
      }
    }
  }, []);
  return [wrapperFocus, contentRef];
};
var _default = AutoFocusOnMount;
exports.default = _default;